<template>
  <div>
    <el-dialog class="myDialogUpLoadImgBig" :close-on-click-modal="false" :visible.sync="dialogVisible"
      :append-to-body="true">
      <img class="bigImg" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <div v-if="dataType == 'img'">
      <div class="imgListCon" v-if="fileName">
        <div class="imgBox" v-for="(imgItem, imgIndex) in imgData" :key="'shjfd' + imgIndex">
          <template v-if="target == 'click'">
            <div class="iconBtnBox">
              <i class="el-icon-search" @click="openDia(imgItem[fileName])"></i>
              <i v-if="showDel" class="el-icon-delete" @click="deleteFileMethods(imgData, imgIndex)"></i>
            </div>
            <el-image :src="imgItem[fileName]">
              <div slot="error" class="image-slot">
                <i class="el-icon-document"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </template>
          <template v-else-if="target == 'hover'">
            <el-popover placement="right" trigger="hover">
              <img :src="imgItem[fileName]" alt="" style="width: 300px; height: 300px" />
              <el-image :src="imgItem[fileName]" slot="reference">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </el-popover>
          </template>
        </div>
      </div>

      <div class="imgListCon" v-else>
        <div class="imgBox" v-for="(imgItem, imgIndex) in imgData" :key="'shsjfd' + imgIndex">
          <template v-if="target == 'click'">
            <div class="iconBtnBox">
              <i class="el-icon-search" @click="openDia(imgItem)"></i>
              <i v-if="showDel" class="el-icon-delete" @click="deleteFileMethods(imgData, imgIndex)"></i>
            </div>
            <el-image :src="imgItem">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </template>
          <template v-else-if="target == 'hover'">
            <el-popover placement="right" trigger="hover">
              <img :src="imgItem" alt="" style="width: 300px; height: 300px" />
              <el-image :src="imgItem" slot="reference">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </el-popover>
          </template>
        </div>
      </div>
    </div>
    <div v-else-if="dataType == 'file'">
      <div class="fileBox" v-for="(imgItem, imgIndex) in imgData" :key="'shsjfd' + imgIndex"
        @click="toLink({ url: imgItem })">
        <i v-if="imgItem" class="el-icon-document"></i>
      </div>
    </div>
    <div v-else-if="dataType == 'video'">
      <div class="imgListCon">
        <div class="imgBox videoBox" v-for="(vvvitem, vvindex) in imgData" :key="'shjfd' + vvindex">
          <div class="iconBtnBox videobox">
            <i v-if="showDel" class="el-icon-delete" @click="deleteFileMethods(imgData, vvindex)"></i>
          </div>
          <video controls loop :key="vvindex">
            <source :src="vvvitem" :type="'video/mp4'" />
            <source :src="vvvitem" :type="'video/dvi'" />
            您的浏览器不支持 video 标签。
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //文件列表
    imgList: {
      default: [],
      type: [Array, String],
    },
    img: {
      default: "",
      type: String,
    },
    // 文件对象数组里指定名字
    fileName: {
      default: "",
      type: String,
    },
    // 是否显示删除按钮
    showDel: {
      default: true,
      type: [Boolean, Function],
    },
    // 文件类型
    dataType: {
      default: "img",
      type: String,
    },
    // 显示方式
    target: {
      default: "click",
      type: String,
    },
  },
  data() {
    return {
      dialogImageUrl: "saf",
      dialogVisible: false,
      delCon: true, //删除事件是否可用
    };
  },
  components: {},
  computed: {
    imgData() {
      if (!this.imgList) {
        return [];
      }
      // 如果是传入的字符型就转换成数组
      if (typeof this.imgList == "string") {
        if (typeof this.showDel != "function") {
          this.delCon = false;
        }
        return [this.imgList];
      }
      return this.imgList;
    },
  },
  created() { },
  mounted() { },
  methods: {
    // 打开查看大图弹窗
    openDia(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 删除文件事件
    deleteFileMethods(data, i) {
      if (typeof this.showDel == "function") {
        this.showDel();
      } else if (this.delCon) {
        data.splice(i, 1);
        this.$forceUpdate();
      } else {
        console.log("当imgList为字符型时showDel必须是自定义删除事件");
      }
    },
    //跳转
    toLink(data) {
      if (data && data.meth) {
        data.meth();
      }
      var url = data.url;
      var el = document.createElement("a");
      document.body.appendChild(el);
      el.href = url; //url 是你得到的连接
      el.target = "_blank"; //指定在新窗口打开
      el.click();
      document.body.removeChild(el);
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
.imgListCon {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  $imgSize: 60px;
  display: flex;
  flex-wrap: wrap;

  video {
    width: 180px;
  }

  .imgBox {
    position: relative;

    &:hover {
      .iconBtnBox {
        height: $imgSize;

        &.videobox {
          height: 30px;
        }
      }
    }
  }

  .iconBtnBox {
    position: absolute !important;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: rgba($color: black, $alpha: 0.5);
    z-index: 1;
    transition: 0.3s;
    display: flex;
    justify-content: space-around;
    align-items: center;

    &.videobox {
      left: unset;
      right: 0px;
      width: 30px;
    }

    i {
      width: 20px;
      height: 20px;
      font-size: 20px;
      color: white;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  /deep/.el-image {
    width: $imgSize !important;
    height: $imgSize !important;
    transition: 0.3s;
    text-align: center;

    i {
      font-size: $imgSize/2;
      line-height: $imgSize;
    }
  }
}



.fileBox {
  cursor: pointer;
}
</style>
<style lang="scss">
.myDialogUpLoadImgBig {
  .el-dialog {
    overflow: auto;
    resize: both;

    .el-dialog__body {
      // 加了之后可以让图片跟随弹框大小
      width: 100%;
      height: 100%;
    }

    .bigImg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>